import { render, staticRenderFns } from "./PersonAccount.vue?vue&type=template&id=b1de3aa2&scoped=true&"
import script from "./PersonAccount.vue?vue&type=script&lang=js&"
export * from "./PersonAccount.vue?vue&type=script&lang=js&"
import style0 from "./PersonAccount.vue?vue&type=style&index=0&id=b1de3aa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1de3aa2",
  null
  
)

export default component.exports